import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Module from "@/models/lms/Module";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";
import CourseModule from "@/models/lms-central/CourseModule";

export default class Course extends GenexLMSModel {
    static entity = 'courses'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            content: this.attr(null),
            image_url: this.attr(null),
            percentage: this.attr(0),
            display_name: this.attr(null),
            outcomes: this.attr(null),
            requirements: this.attr(null),
            level: this.attr(null),
            completed_at: this.attr(null),
            created_at: this.attr(null),
            course_scope_code: this.attr(null),
            updated_at: this.attr(null),
            modules: this.hasManyBy(Module, 'module_ids'),
            module_ids: this.attr(() => []),
            number: this.uid(),
            course_modules: this.hasMany(CourseModule, 'course_id'),

            // type: this.attr('courses'),
            // created_user_id: this.attr(null),
            // active: this.attr(0),
            // slug: this.attr(null),
            // video_url: this.attr(null),
            // status: this.attr(null),
            // points_on_start: this.attr(0),
            // points_on_complete: this.attr(0),
            // module_points_override: this.attr(0),
            // course_scope_code: this.attr(null),
            // current_user_percentage: this.attr(null),
            // current_user_completed: this.attr(null),
            // current_user_start_date: this.attr(null),
        }
    }

    /**
     * Returns all courses for the user
     * @function
     * @param {Object} pagination
     * @param {number} pagination.page - Which page to retrieve
     * @param {number} pagination.limit - How many entities to retrieve
     * @param {?Object} [query={}] - Query terms for the request
     * @param {?string} [query.modules]
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchAll({page = 1, limit = 15}, query = {}, relationships = []) {
        return this.api().get(`/courses`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        page: page, limit: limit, with: relationships
                    }, ...(query !== {} ? query : {}),
                },
                dataTransformer: ({data: {data}}) => {
                    return GenexHelperMixins.methods.NormalizeRecursive(data);
                },
            }
        )
    }

    /**
     * Returns a course
     * @function
     * @param {number} course_id - The course_id
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchById(course_id, relationships = []) {
        return this.api().get(`courses/${course_id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                persistBy: 'create',
                params: {
                    ...{
                        with: relationships
                    },
                },
                dataTransformer: ({data: {data}}) => {
                    if (relationships.includes('modules')) {
                        if (Object.prototype.hasOwnProperty.call(data.attributes, 'modules')) {
                            data.attributes.modules.map(module => {
                                if (Object.prototype.hasOwnProperty.call(module.attributes, 'lessons')) {
                                    module.attributes.lessons.map(lesson => {
                                        Object.assign(lesson, lesson.attributes)
                                    })
                                }
                                Object.assign(module, module.attributes)

                            })

                        }
                    }
                    return {...data, ...data.attributes}
                },
            }
        )
    }

    static FetchByIdStructured(course_id, relationships = [], persistBy = "insertOrUpdate") {
        return this.api().get(`courses/${course_id}/structure`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                persistBy: persistBy,
                params: {
                    ...{
                        with: relationships
                    },
                },
                dataTransformer: ({data: {data}}) => {
                    if (relationships.includes('modules')) {
                        if (Object.prototype.hasOwnProperty.call(data.attributes, 'modules')) {
                            data.attributes.modules.map(module => {
                                if (Object.prototype.hasOwnProperty.call(module.attributes, 'lessons')) {
                                    module.attributes.lessons.map(lesson => {
                                        Object.assign(lesson, lesson.attributes)
                                    })
                                }
                                Object.assign(module, module.attributes)

                            })

                        }
                    }
                    return {...data, ...data.attributes}
                },
            }
        )
    }

}
